export function darkMode($) {
  jQuery(document).ready(function ($) {
    var isDarkModeActive = false; // Track dark mode status

    // Function to toggle dark mode based on visibility
    function toggleDarkMode(entries) {
      entries.forEach(function (entry) {
        if (entry.target.classList.contains('dark-mode-wrapper')) {
          var visiblePixels = entry.boundingClientRect.height * entry.intersectionRatio;

          // Check if at least 300px of the element is visible
          if (entry.isIntersecting && visiblePixels >= 300) {
            if (!isDarkModeActive) {
              $('body').addClass('dark-mode');
              isDarkModeActive = true;
            }
          } else {
            if (isDarkModeActive) {
              $('body').removeClass('dark-mode');
              isDarkModeActive = false;
            }
          }
        }
      });
    }

    // Create the Intersection Observer
    var observer = new IntersectionObserver(function (entries) {
      toggleDarkMode(entries);
    }, {
      root: null,
      // Use the viewport as the root
      rootMargin: "0px 0px 0px 0px",
      // No extra margins
      threshold: Array.from({
        length: 101
      }, function (_, i) {
        return i / 100;
      }) // Generate thresholds from 0.01 to 1.0
    });

    // Select all `.dark-mode-wrapper` elements and observe each one
    var darkModeWrappers = document.querySelectorAll('.dark-mode-wrapper');
    darkModeWrappers.forEach(function (wrapper) {
      observer.observe(wrapper);
    });
  });
}